import jsPDF from 'jspdf';
import { formatDateTime, formatCurrency } from '../Helpers';
import { addCustomFont } from './pdfFonts';

export const generateReceiptPDF = (saleDetail, shopName = 'StoreFlow') => {
    const pdf = new jsPDF();

    // Set optimal font for receipts
    const fontName = addCustomFont(pdf, 'receipt');

    // Page margins and layout
    const leftMargin = 20;
    const rightMargin = 190;

    // Header section with professional styling
    pdf.setFontSize(24);
    pdf.setFont(fontName, 'bold');
    pdf.text(shopName, leftMargin, 25);

    pdf.setFontSize(14);
    pdf.setFont(fontName, 'normal');
    pdf.text('SALES RECEIPT', leftMargin, 35);

    // Add decorative line under header
    pdf.setLineWidth(0.5);
    pdf.line(leftMargin, 40, rightMargin, 40);

    // Transaction details section
    pdf.setFontSize(11);
    pdf.setFont(fontName, 'normal');

    const detailsStartY = 55;
    pdf.text(`Receipt No: ${saleDetail.id.substring(0, 10).toUpperCase()}`, leftMargin, detailsStartY);
    pdf.text(`Date & Time: ${formatDateTime(saleDetail.saleDate)}`, leftMargin, detailsStartY + 8);

    if (saleDetail.customer?.name) {
        pdf.text(`Name: ${saleDetail.customer.name}`, leftMargin, detailsStartY + 16);
    }
    if (saleDetail.customer?.phone) {
        pdf.text(`Contact: ${saleDetail.customer.phone}`, leftMargin, detailsStartY + 24);
    }

    // Payment method
    const paymentMethodLabel = (saleDetail.paymentMethod || 'cash').toUpperCase();
    pdf.text(`Payment: ${paymentMethodLabel}`, leftMargin, detailsStartY + 32);

    // Items section with professional table
    const itemsStartY = detailsStartY + 40;

    // Items header with background
    pdf.setFillColor(240, 240, 240);
    pdf.rect(leftMargin, itemsStartY - 5, rightMargin - leftMargin, 12, 'F');

    pdf.setFontSize(12);
    pdf.setFont(fontName, 'bold');
    pdf.text('ITEM DETAILS', leftMargin + 2, itemsStartY + 2);

    // Table headers
    const tableStartY = itemsStartY + 15;
    pdf.setFontSize(10);
    pdf.setFont(fontName, 'bold');
    pdf.text('Item Name', leftMargin, tableStartY);
    pdf.text('Qty', 120, tableStartY);
    pdf.text('Rate', 140, tableStartY);
    pdf.text('Amount', 170, tableStartY);

    // Table header line
    pdf.setLineWidth(0.3);
    pdf.line(leftMargin, tableStartY + 3, rightMargin, tableStartY + 3);

    // Items list
    pdf.setFont(fontName, 'normal');
    let yPosition = tableStartY + 12;

    saleDetail.items.forEach((item) => {
        const itemName = item.itemName.length > 25 ?
            item.itemName.substring(0, 25) + '...' : item.itemName;

        pdf.text(itemName, leftMargin, yPosition);
        pdf.text(item.quantity.toString(), 120, yPosition);
        pdf.text(`${formatCurrency(item.sellingPrice)}`, 140, yPosition);
        pdf.text(`${formatCurrency((item.quantity * item.sellingPrice).toFixed(2))}`, 170, yPosition);

        yPosition += 8;
    });

    // Total section
    const totalSectionY = yPosition + 10;

    // Total line separator
    pdf.setLineWidth(0.5);
    pdf.line(leftMargin, totalSectionY, rightMargin, totalSectionY);

    // Total amount with emphasis
    pdf.setFontSize(14);
    pdf.setFont(fontName, 'bold');
    pdf.text('TOTAL AMOUNT:', leftMargin, totalSectionY + 12);
    pdf.text(`${formatCurrency(saleDetail.totalAmount.toFixed(2))}`, 170, totalSectionY + 12);

    // Footer section
    const footerY = totalSectionY + 35;
    pdf.setFontSize(10);
    pdf.setFont(fontName, 'italic');
    pdf.text('Thank you for your business!', leftMargin, footerY);

    pdf.setFontSize(8);
    pdf.setFont(fontName, 'normal');
    pdf.text(`Generated by ${shopName} - ${new Date().toLocaleDateString()}`, leftMargin, footerY + 10);

    // Add professional border around the entire receipt
    pdf.setLineWidth(0.5);
    pdf.rect(15, 15, 180, footerY + 5);

    // Generate filename with shop name and date
    const receiptDate = new Date().toISOString().split('T')[0];
    const filename = `${shopName.replace(/\s+/g, '_')}_Receipt_${receiptDate}_${saleDetail.id.substring(0, 6)}.pdf`;

    return { pdf, filename };
};